"use client";
import l, { createContext as p, useContext as u } from "react";
import { t as f } from "./tv.config-BuYIgndg.mjs";
import { u as C } from "./useRender-DCcXqLqs.mjs";
import { m as P } from "./useRenderElement-B8V3_e8R.mjs";
const E = f({
  base: ["aspect-video"],
  variants: {
    position: {
      top: [],
      middle: [],
      bottom: []
    },
    isMedia: {
      true: ["w-full"]
    }
  }
}), v = p({
  mediaPosition: "top",
  contentPosition: "middle",
  actionPosition: "bottom",
  headerPosition: "top"
}), M = (t) => {
  const { src: e, className: o, render: s, alt: n, ref: r, ...a } = t, { mediaPosition: i } = u(v), d = e ? "img" : "div", m = s ?? l.createElement(d), c = {
    ...e && { src: e, alt: n },
    className: E({
      position: i,
      class: o,
      isMedia: e !== void 0
    }),
    ref: r
  };
  return C({
    render: m,
    props: P(c, a)
  });
}, _ = (t) => M(t);
export {
  _ as C,
  v as a
};
